<template>
	<tr @dblclick="rowDbClicked" class="grid-row" ref="targetEl" :style="`min-height:${fixedMinHeight ? fixedMinHeight : minHeight}px`" :class="{
		'grid-row-active': index === activeRowIndex,
		'grid-row-selected': item.$___checked,
		'grid-row-changed': item.$___dirtyCells.length > 0,
		'grid-row-deleted': item.rowState === 'deleted',
		'grid-row-new': item.rowState === 'new',
		'grid-row-error': !item.$___valid,
		'grid-row-lock': item.$___locked,
	}" :data-row="item.id">
		<grid-cell v-if="shouldRender" @cell_mounted="$emit('cell_mounted')" @cell_focused_out="$emit('cell_focused_out')" :settings="settings" :item="item" :filteredData="filteredData" :gridId="gridId" :isRowDisabled="isRowDisabled" :index="index" :activeRowIndex="activeRowIndex" :filteredColumns="filteredColumns" @data-changed="(obj) => $emit('data-changed', obj)" @row_checkboxClicked="(obj) => $emit('row_checkboxClicked', obj)" @focus_cellClicked="(obj) => $emit('focus_cellClicked', obj)"
			@focus_cellClickedByCtrl="(obj) => $emit('focus_cellClickedByCtrl', obj)" />
	</tr>
</template>
<script>
	import gridCell from "./grid-cell.vue"
	import { useIntersectionObserver } from "@vueuse/core"
	import { ref, nextTick } from "vue"

	function onIdle(cb = () => { }) {
		if ("requestIdleCallback" in window) {
			window.requestIdleCallback(cb)
		} else {
			setTimeout(() => {
				nextTick(cb)
			}, 300)
		}
	}

	export default {
		components: {
			'grid-cell': gridCell,
		},
		props: {
			item: Object,
      filteredData: Array,
			gridId: String,
			index: Number,
			activeRowIndex: Number,
			settings: Object,
			filteredColumns: Array,
			renderOnIdle: Boolean,
			unrender: Boolean,
			minHeight: Number,
			unrenderDelay: {
				type: Number,
				default: 10000,
			},
			isRowDisabled: Boolean,
		},
		emits: ['focus_cellClickedByCtrl', 'row_dbClicked', 'data-changed', 'row_checkboxClicked', 'focus_cellClicked', 'cell_mounted', 'cell_focused_out'],
		data() {
			return {
				shouldRender: false,
				targetEl: null,
				fixedMinHeight: 0,
			}
		},
		mounted() {
			this.targetEl = this.$refs.targetEl
			let unrenderTimer
			let renderTimer

			const { stop } = useIntersectionObserver(
				this.targetEl,
				([{ isIntersecting }]) => {
					if (isIntersecting) {
						// perhaps the user re-scrolled to a component that was set to unrender. In that case stop the unrendering timer
						clearTimeout(unrenderTimer)
						// if we're dealing underndering lets add a waiting period of 200ms before rendering. If a component enters the viewport and also leaves it within 200ms it will not render at all. This saves work and improves performance when user scrolls very fast
						renderTimer = setTimeout(
							() => (this.shouldRender = true),
							this.unrender ? 200 : 0
						)
						this.shouldRender = true
						if (!this.unrender) {
							stop()
						}
					} else if (this.unrender) {
						// if the component was set to render, cancel that
						clearTimeout(renderTimer)
						unrenderTimer = setTimeout(() => {
							this.fixedMinHeight = this.targetEl.clientHeight
							this.shouldRender = false
						}, this.unrenderDelay)
					}
				},
				{
					rootMargin: "600px",
				}
			)


			if (this.renderOnIdle) {
				onIdle(() => {
					this.shouldRender = true
					if (!this.unrender) {
						stop()
					}
				})
			}

		},
		methods: {
			rowDbClicked(e) {
				this.$emit('row_dbClicked', this.index, e)
			}
		}
	}
</script>
